<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <PageForm :basePage="page" :loading="loading" @submit-requested="submitRequested"></PageForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import PageForm from './PageForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                page: null,
                loading: true
            }
        },
        components: { PageForm },
        computed:
        {
            ...mapState('pages', ['getPageBySlugOutput']),
        },
        methods: {
            ...mapActions('pages', ['getPageBySlug']),
            ...mapActions('pages', ['putPage']),
            submitRequested(page) {
                this.putPage(page);
            },
        },
        mounted: function () {
            if (!this.$route.params.slug) {
                router.push({name: 'Pages'});
            }
            else {
                this.getPageBySlug(this.$route.params.slug);
            }
        },
        watch:
        {
            getPageBySlugOutput: function (output) {
                if (!output) {
                    router.push({name: 'Pages'});
                }
                else {
                    this.page = output;
                    this.loading = false;
                }
            }
        }
    }
</script>